import { useMutation } from '@apollo/client/react';
import { toast } from 'sonner';

import { EscrowRequestCertifiedAddonDocument } from 'src/graphql/actions/escrow/escrowRequestCertifiedAddon.mutation';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { getApiError, ClientError } from 'src/utils/errors';
import { Button } from '@/components/ui/button';
import { RequestCertifiedLevelDialog } from '@/widgets/VerificationAddOns';

type Props = {
  buttonText?: string;
};

const RequestCertifiedAction = ({ buttonText = 'Contact us' }: Props) => {
  const [requestCertifiedAddon] = useMutation(EscrowRequestCertifiedAddonDocument);
  const {
    softwareEscrow: { id: escrowId, policy },
  } = useSoftwareEscrow();

  const onSendRequest = async ({ message = '' }) => {
    try {
      const { data } = await requestCertifiedAddon({ variables: { escrowId, message } });
      if (data?.escrowRequestCertifiedAddon?.errors?.length) {
        throw new ClientError(data?.escrowRequestCertifiedAddon?.errors[0]);
      } else
        toast.success('Request sent', {
          description: 'We’ve got your request. We’ll get in touch shortly.',
        });
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  if (!policy.enableReports) return null;

  return (
    <RequestCertifiedLevelDialog
      triggerNode={
        <Button size="sm" variant="secondary" className="w-full">
          {buttonText}
        </Button>
      }
      onSendRequest={onSendRequest}
    />
  );
};

export default RequestCertifiedAction;
